module.exports = __webpack_public_path__ + "img/ring_g_l_null_null@3x.e2f89de5.png";